import { apiPost } from '@maestro/core/api-client'

interface DiagnosticPayload {
  level: 'warn' | 'error'
  message: string
  context: Record<string, unknown>
}

export function reportDiagnostic(data: DiagnosticPayload): Promise<unknown> {
  return apiPost('/api/diagnostics/log', data)
}
